export const YUZ_MECNUN = [
  {
    id: "yl001",
    metin: "{{ad}}, yüzüne bakarken bir derinlik hissettim. {{soru}} konusunda şunu söyleyeyim: gözlerin her şeyi anlatıyor. O gözlerde hem acı hem umut var — ikisi bir arada. Bu denge, güçlü bir ruhun işareti.\n\nNe acıyı inkâr et ne de umudu bırak. İkisini birlikte taşıyabilmek — bu olgunluğun en güzel halidir.",
    tema: "goz"
  },
  {
    id: "yl002",
    metin: "{{ad}}, alnındaki o ince çizgiye bak. Düşünen bir zihin bu. {{soru}} konusunda çok düşünüyorsun — bazen gereğinden fazla.\n\nZihni sustur, kalbi dinle. Cevap orada. Zihin seçenekler üretir, kalp doğru olanı gösterir. Bu sefer kalbe öncelik ver.",
    tema: "zihin"
  },
  {
    id: "yl003",
    metin: "{{ad}}, çene yapın güçlü — bu irade ve kararlılık demek. {{soru}} konusunda bir karar verdin mi henüz? Çenen bana evet diyebileceğini söylüyor.\n\nİnan kendine. İrade dışarıdan gelmez — içeriden çıkar. Ve seninkisi orada, hazır bekliyor.",
    tema: "irade"
  },
  {
    id: "yl004",
    metin: "{{ad}}, elmacık kemiklerin belirgin. Yüz okumada bu sosyal güç ve çevre demek. {{soru}} konusunda çevren sana yardımcı olacak.\n\nDoğru insanlarla bağlantıda kal. Ağını genişlet, kapıları kapat. Bazen bir tanıdık, bir söz — her şeyi değiştirir.",
    tema: "sosyal"
  },
  {
    id: "yl005",
    metin: "{{ad}}, gözlerinin rengi ve parıltısı bana çok şey söylüyor. {{soru}} konusunda içinde yanan bir ateş var — sönmemiş, sadece küçülmüş.\n\nO ateşi besle, körükle. Küçük alev büyük ateşin başlangıcıdır. Vazgeçme — o ateş senin en güçlü yanın.",
    tema: "ates"
  },
  {
    id: "yl006",
    metin: "{{ad}}, kaşların şekline bak. Yay gibi kıvrılmış — bu sezgisel bir zihin demek. {{soru}} konusunda mantığından önce sezgine güven.\n\nİlk his genellikle doğrudur. Onu bastırmak yerine dinle. Sezgi, deneyimin sessiz birikmesinden doğar — ve seninki çok şey biriktirmiş.",
    tema: "sezgi"
  },
  {
    id: "yl007",
    metin: "{{ad}}, dudaklarının şekli bana şefkat ve empati söylüyor. {{soru}} konusunda başkalarına çok şefkat gösteriyorsun, kendine az.\n\nBu dengeyi değiştir. Kendine şefkat göstermek bencillik değil — sürdürülebilirlik. Boş kap başkasına veremez.",
    tema: "sefkat"
  },
  {
    id: "yl008",
    metin: "{{ad}}, burnunun şekline bak — güçlü ve belirgin. Yüz okumada bu liderlik ve iş zekası demek. {{soru}} konusunda iş ve kariyer alanında güçlü bir hamle vakti.\n\nÖne çık. Geri durmak sana yakışmıyor. Liderlik fırsat beklemez — fırsat yaratır.",
    tema: "kariyer"
  },
  {
    id: "yl009",
    metin: "{{ad}}, kulak yapın bana ilginç bir şey söylüyor — dinleyici bir ruh. {{soru}} konusunda şu an dinleme vakti.\n\nKonuşmaktan çok dinle. Cevap sana söylenecek — ama yalnızca dinlersen duyulur. Sessizlik bazen en güçlü konuşmadır.",
    tema: "dinleme"
  },
  {
    id: "yl010",
    metin: "{{ad}}, alnının genişliği bana entelektüel bir kapasite gösteriyor. {{soru}} konusunda bu zekâyı kullan. Çözüm karmaşık değil — sadece farklı bir bakış açısı gerekiyor.\n\nAlışılmışın dışından bak. Aynı yerden bakınca aynı şeyleri görürsün. Yerini değiştir, perspektif değişir.",
    tema: "zeka"
  },
  {
    id: "yl011",
    metin: "{{ad}}, yüzündeki simetri ilginç. Tam simetrik değil — hiçbir yüz değil zaten. Ama bu asimetri karakterini gösteriyor. {{soru}} konusunda mükemmel olmaya çalışma.\n\nGerçek ol. Mükemmellik soğuk ve uzak görünür. Gerçeklik ise sıcak ve erişilebilir. İnsanlar mükemmele hayran olur, gerçeğe bağlanır.",
    tema: "gerceklik"
  },
  {
    id: "yl012",
    metin: "{{ad}}, gözlerinin altındaki o hafif iz yorgunluğu mu gösteriyor, derin düşünceyi mi? {{soru}} konusunda hem yorgunsun hem de çok düşünüyorsun.\n\nDur, nefes al, sonra devam et. Yorgun zihin en iyi kararları vermez. Dinlenmek tembellik değil — stratejidir.",
    tema: "dinlenme"
  },
  {
    id: "yl013",
    metin: "{{ad}}, yüzün bana bir hikaye anlatıyor — uzun, zorlu ama güzel bir hikaye. {{soru}} konusunda bu hikayenin en güzel bölümü henüz yazılmadı.\n\nKalem sendedir. Ve en iyi yazarlar, en zor dönemlerden sonra en güzel sayfaları yazar.",
    tema: "hikaye"
  },
  {
    id: "yl014",
    metin: "{{ad}}, çene çizgine bak — güçlü ama esnek. Bu sertlik ve yumuşaklığın dengesi. {{soru}} konusunda ne zaman sert ne zaman yumuşak olacağını bil.\n\nİkisi de gerekli. Yalnızca sert olan kırar, yalnızca yumuşak olan şeklini kaybeder. Denge en güçlü haldir.",
    tema: "denge"
  },
  {
    id: "yl015",
    metin: "{{ad}}, gözlerinde bir arayış var. {{soru}} konusunda aradığın şey dışarıda değil içeride. Aynaya bak — gerçekten bak.\n\nCevap orada. Her zaman oradaydı. Dışarıda arama yorar — içeride bulmak özgürleştirir.",
    tema: "ic_arayis"
  },
  {
    id: "yl016",
    metin: "{{ad}}, yüzünün genel enerjisi bana su elementi söylüyor — akışkan, derin, değişken. {{soru}} konusunda akışa bırak kendini.\n\nZorlamak suyu durdurmuyor, yavaşlatıyor. Su engeli aşmaz — çevreler. O esnekliği al, uygula.",
    tema: "akis"
  },
  {
    id: "yl017",
    metin: "{{ad}}, kaşların arasındaki o nokta — üçüncü göz bölgesi. Bu bölgede güçlü bir enerji hissediyorum. {{soru}} konusunda sezgilerin çok güçlü şu an.\n\nOnlara kulak ver. Üçüncü göz görmek için değil — hissetmek için açılır. O hissi bastırma.",
    tema: "ucuncu_goz"
  },
  {
    id: "yl018",
    metin: "{{ad}}, gülümsediğinde gözlerin de gülümseyen türdensin — bunu hissedebiliyorum. {{soru}} konusunda o gülümsemeyi kaybetme.\n\nNeşe en güçlü kalkan. Dışarıdan gelen karanlığa karşı içeriden gelen ışık — bu gülümseme o ışık.",
    tema: "nes"
  },
  {
    id: "yl019",
    metin: "{{ad}}, yüzündeki o asil duruş bana güçlü bir karakter söylüyor. {{soru}} konusunda karakterini koru. Baskı altında bile eğilme.\n\nKarakter en zor anda ortaya çıkar — ve senin karakterin o baskıyı kaldıracak güçte. Bil bunu.",
    tema: "karakter"
  },
  {
    id: "yl020",
    metin: "{{ad}}, gözlerinin derinliğinde bir bilgelik var — yaşından fazla. {{soru}} konusunda bu bilgeliği kullan.\n\nİçindeki yaşlı ruh sana doğru yolu gösterecek. Ona güven. Yaşanan her şey o bilgeliğe katkı yapmıştır — boşa gitmemiş.",
    tema: "bilgelik"
  },
  {
    id: "yl021",
    metin: "{{ad}}, yüzünün sol tarafı sağ tarafından biraz farklı. Sol taraf iç dünyayı, sağ taraf dış dünyayı gösterir. {{soru}} konusunda iç ve dış dünyan arasında bir gerilim var.\n\nUyumu bul. İçeride hissettiğinle dışarıda gösterdiğin örtüşsün. Bu uyum hem seni hem çevrendekileri rahatlatır.",
    tema: "uyum"
  },
  {
    id: "yl022",
    metin: "{{ad}}, alnındaki çizgiler bana bir harita gibi görünüyor. {{soru}} konusunda hayatın bir harita gibi — bazı yollar kapalı, bazıları açık.\n\nAçık olanı seç, kapalıya çarpma. Kapalı yollar zaman kaybettirir. Açık yollar ise sürpriz manzaralar sunar.",
    tema: "yol"
  },
  {
    id: "yl023",
    metin: "{{ad}}, yüzündeki o dinginlik beni şaşırttı. İçinde fırtına var ama dışarıda sakinsin. {{soru}} konusunda bu dinginliği ödünç ver kendine — içindeki fırtınayı da sakinleştir.\n\nDışarıdan içeriye de akar bazen. Sakin davranmak, sakin hissetmeye başlatır. Dene.",
    tema: "dinginlik"
  },
  {
    id: "yl024",
    metin: "{{ad}}, gözlerinin rengi ne olursa olsun — o parıltı özel. {{soru}} konusunda o parıltıyı söndüren ne varsa hayatından çıkar.\n\nIşığını koru. Her şey gidebilir ama o parıltı gitmesin. O parıltı senin özündür — korumaya değer.",
    tema: "isik"
  },
  {
    id: "yl025",
    metin: "{{ad}}, son olarak yüzün bana şunu söylüyor: sen sandığından çok daha güzelsin — içten ve dıştan. {{soru}} konusunda kendini küçümseme alışkanlığını bırak.\n\nDeğerini bil. Değerin çok. Ve değerini bilen insan, değerini bilen insanları hayatına çeker.",
    tema: "deger"
  }
];